import IFilterModel from "../IFilterModel";

type UserSubscriptionStatus = "Free" | "Active" | "Expired" | null;
type UserSubscriptionStatusValue =
  | UserSubscriptionStatus
  | { id?: UserSubscriptionStatus; Id?: UserSubscriptionStatus };

export default class UserFilterModel implements IFilterModel {
  search: string = "";
  subscriptionStatus: UserSubscriptionStatusValue = null;

  resetToDefault() {
    this.search = "";
    this.subscriptionStatus = null;
  }

  toFilterRequest(): any {
    return {
      Search: this.search ? this.search.trim() : null,
      SubscriptionStatus: this.getSubscriptionStatusValue(),
    };
  }

  restoreFromFilterRequest(request: any) {
    this.search = request && typeof request.Search === "string" ? request.Search : "";
    this.subscriptionStatus = this.readSubscriptionStatus(request);
  }

  private getSubscriptionStatusValue(): UserSubscriptionStatus {
    return this.readSubscriptionStatus({ value: this.subscriptionStatus });
  }

  private readSubscriptionStatus(source: any): UserSubscriptionStatus {
    const value =
      source && source.value !== undefined
        ? source.value
        : source && (source.SubscriptionStatus || source.subscriptionStatus);

    if (
      value === "Free" ||
      value === "Active" ||
      value === "Expired"
    ) {
      return value;
    }

    if (value && typeof value === "object") {
      return value.id || value.Id || null;
    }

    return null;
  }
}
